import { render } from "./HospitalsFilter.vue?vue&type=template&id=29d71b7b&ts=true"
import script from "./HospitalsFilter.vue?vue&type=script&lang=ts"
export * from "./HospitalsFilter.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__